import React from "react";
import "./index.css"

export default function CeaseFire() {
  return (
    <div className="banner">
      <a href="https://ceasefiretoday.com/" target="_blank" rel="noreferrer" referrerPolicy="no-referrer">
      # CeasefireNow! <span role="img" aria-label="palestine emoji">🇵🇸</span></a>
    </div>
  );
}
